module.exports = __webpack_public_path__ + "img/materialMachine.648b5d2e.svg";